"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseISCNTxRecordFromQuery = exports.parseISCNTxInfoFromIndexedTx = exports.parseISCNRecordFields = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const proto_signing_1 = require("@cosmjs/proto-signing");
const tx_1 = require("@likecoin/iscn-message-types/dist/iscn/tx");
function parseISCNRecordFields(record) {
    const { stakeholders, contentMetadata, } = record;
    return Object.assign(Object.assign({}, record), { stakeholders: stakeholders.map((s) => {
            if (s) {
                const sString = Buffer.from(s).toString('utf-8');
                if (sString)
                    return JSON.parse(sString);
            }
            return s;
        }), contentMetadata: JSON.parse(Buffer.from(contentMetadata).toString('utf-8')) });
}
exports.parseISCNRecordFields = parseISCNRecordFields;
function parseISCNTxInfoFromIndexedTx(tx) {
    const { tx: txBytes, rawLog } = tx;
    const decodedTx = (0, proto_signing_1.decodeTxRaw)(txBytes);
    const messages = decodedTx.body.messages.map((m) => {
        let msg;
        if (m.typeUrl === '/likechain.iscn.MsgCreateIscnRecord') {
            msg = tx_1.MsgCreateIscnRecord.decode(m.value);
            if (msg.record) {
                msg.record = parseISCNRecordFields(msg.record);
            }
        }
        if (m.typeUrl === '/likechain.iscn.MsgUpdateIscnRecord') {
            msg = tx_1.MsgUpdateIscnRecord.decode(m.value);
            if (msg.record) {
                msg.record = parseISCNRecordFields(msg.record);
            }
        }
        if (m.typeUrl === '/likechain.iscn.MsgChangeIscnRecordOwnership') {
            msg = tx_1.MsgChangeIscnRecordOwnership.decode(m.value);
        }
        return msg ? Object.assign(Object.assign({}, m), { value: msg }) : null;
    });
    return Object.assign(Object.assign({}, tx), { logs: JSON.parse(rawLog), tx: Object.assign(Object.assign({}, decodedTx), { body: Object.assign(Object.assign({}, decodedTx.body), { messages: messages.filter((m) => !!m) }) }) });
}
exports.parseISCNTxInfoFromIndexedTx = parseISCNTxInfoFromIndexedTx;
function parseISCNTxRecordFromQuery(records) {
    return records.map((r) => {
        const { data, ipld } = r;
        const parsedData = JSON.parse(Buffer.from(data).toString('utf-8'));
        return {
            ipld,
            data: parsedData,
        };
    });
}
exports.parseISCNTxRecordFromQuery = parseISCNTxRecordFromQuery;
//# sourceMappingURL=parsing.js.map